/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190703 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable } from '@angular/core';
import { MaskDefinition } from 'src/app/_model/mask-definition';
import { KeyValuePersistenceService } from 'src/app/_services/persistence/key-value-persistence/key-value-persistence.service';
import { MaskDefinitionDaoService } from '../mask-definition-dao.service';

// CONSTANTS
const MASK_DEFINITION_KEY = 'maskdefinition';

@Injectable()
export class MaskDefinitionStorageDaoService implements MaskDefinitionDaoService {
  constructor(private keyValueStorage: KeyValuePersistenceService) {}

  public saveMaskDefinitionsData(maskDefinitionData: any): Promise<void> {
    return this.keyValueStorage.store(MASK_DEFINITION_KEY, maskDefinitionData);
  }
  public getMaskDefinitionsData(): Promise<any> {
    return this.keyValueStorage.load(MASK_DEFINITION_KEY);
  }

  public async reset() {}

  public async clear() {
    await this.keyValueStorage.delete(MASK_DEFINITION_KEY);
  }
}
